import { render, staticRenderFns } from "./SupportModal.vue?vue&type=template&id=467e106e&scoped=true"
import script from "./SupportModal.vue?vue&type=script&lang=js"
export * from "./SupportModal.vue?vue&type=script&lang=js"
import style0 from "./SupportModal.vue?vue&type=style&index=0&id=467e106e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467e106e",
  null
  
)

export default component.exports